import { GlFilteredSearchSuggestion } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { __ } from '~/locale';
import BaseToken from './base_token.vue?vue3';
import { stripQuotes } from '~/lib/utils/text_utility';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { OPTIONS_NONE_ANY } from '../constants';
export default {
    name: 'EmojiToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            emojis: this.config.initialEmojis || [],
            loading: false
        };
    },
    computed: {
        defaultEmojis () {
            return this.config.defaultEmojis || OPTIONS_NONE_ANY;
        }
    },
    methods: {
        getActiveEmoji (emojis, data) {
            return emojis.find((emoji)=>this.getEmojiName(emoji).toLowerCase() === stripQuotes(data).toLowerCase());
        },
        getEmojiName (emoji) {
            return emoji.name;
        },
        fetchEmojis (searchTerm) {
            this.loading = true;
            this.config.fetchEmojis(searchTerm).then((response)=>{
                this.emojis = Array.isArray(response) ? response : response.data;
            }).catch(()=>{
                createAlert({
                    message: __('There was a problem fetching emoji.')
                });
            }).finally(()=>{
                this.loading = false;
            });
        }
    }
};
